import { AllocatedPortDataInput } from './allocated-port-data-input.model';


export class DeviceModelSpecificationUpdateInput implements IDeviceModelSpecificationUpdateInput {
    /** The auto-generated id of the device model port specification master */
    deviceModelPortSpecificationId!: number;
    /** The auto-generated id of the device model master */
    deviceModelId!: number;
    /** The property name with 255 character limit */
    propertyName!: string;
    /** The readingType should be Direct or Inverse  */
    readingType!: string;
    /** The work hour calculation should be 0 or 1 */
    workHourCalculation!: number;
    allocatedPortData!: AllocatedPortDataInput[];

    constructor(data?: IDeviceModelSpecificationUpdateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceModelPortSpecificationId = _data["deviceModelPortSpecificationId"];
            this.deviceModelId = _data["deviceModelId"];
            this.propertyName = _data["propertyName"];
            this.readingType = _data["readingType"];
            this.workHourCalculation = _data["workHourCalculation"];
            if (Array.isArray(_data["allocatedPortData"])) {
                this.allocatedPortData = [] as any;
                for (let item of _data["allocatedPortData"])
                    this.allocatedPortData!.push(AllocatedPortDataInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DeviceModelSpecificationUpdateInput {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceModelSpecificationUpdateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceModelPortSpecificationId"] = this.deviceModelPortSpecificationId;
        data["deviceModelId"] = this.deviceModelId;
        data["propertyName"] = this.propertyName;
        data["readingType"] = this.readingType;
        data["workHourCalculation"] = this.workHourCalculation;
        if (Array.isArray(this.allocatedPortData)) {
            data["allocatedPortData"] = [];
            for (let item of this.allocatedPortData)
                data["allocatedPortData"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDeviceModelSpecificationUpdateInput {
    /** The auto-generated id of the device model port specification master */
    deviceModelPortSpecificationId: number;
    /** The auto-generated id of the device model master */
    deviceModelId: number;
    /** The property name with 255 character limit */
    propertyName: string;
    /** The readingType should be Direct or Inverse  */
    readingType: string;
    /** The work hour calculation should be 0 or 1 */
    workHourCalculation: number;
    allocatedPortData: AllocatedPortDataInput[];
}

